<template>
<div ref="container" class="container">
  <span ref="inner" :class="{'scrolling-text': textShouldScroll}">{{text}}</span>
</div>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from 'vue';

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  disable: {
    type: Boolean,
    default: false,
  },
});

const container = ref(null as HTMLDivElement | null);
const inner = ref(null as HTMLDivElement | null);

const checkOverflow = () => {
  if (container.value && inner.value) {
    const containerWidth = container.value.offsetWidth;
    const textWidth = inner.value.offsetWidth;
    const scrollWidth = `${containerWidth - textWidth}px`;
    inner.value.style.setProperty('--scroll-width', scrollWidth);
  }
};

onMounted(() => {
  checkOverflow();
});

const textShouldScroll = computed(() => {
  return !props.disable && container.value && inner.value && inner.value.offsetWidth > container.value.offsetWidth;
});
</script>

<style lang="scss" scoped>
@keyframes scrollText {
  0%, 20%, 100% {
    transform: translateX(0%);
  }
  50%, 70% {
    transform: translateX(var(--scroll-width));
  }
}

.scrolling-text {
  display: inline-block;
  overflow: unset;
  text-overflow: unset;
  white-space: nowrap;
  animation: scrollText 7.5s linear infinite;
}

.container {
  overflow: hidden;
  white-space: nowrap;
}
</style>
